<div class="st-drawer-wrapper">
  <a href=""></a>
  <div class="st-drawer-header lg-p-x show-border">
    <p class="text-header-16">Detalles del contenedor</p>
    <app-st-icon (click)="close()" class="text-header-16 cursor-pointer" [name]="'close'" [bold]="true"></app-st-icon>
  </div>
  <div class="st-drawer-content">
    @if (nzData.readonly) {
      <div class="flex gap-200">
        <app-st-icon [bigAvatar]="true" [avatar]="true" [bold]="true" [name]="'calendar_view_week'"></app-st-icon>
        <div style="justify-content: space-between" class="flex flex-column">
          <p class="text-header-24">{{nzData.container.containerRef}}</p>

          <div style="padding: 3px 8px" class="st-badget subtle-teal">
            <label>{{ nzData.container.containerType?.description }}</label>
          </div>
        </div>
      </div>

      <app-list-key-value [keysWidth]="{value: 160, unit: 'px'}"
                          [innerRowGap]="{value: 24, unit: 'px'}"
                          [innerColumnGap]="{value: 16, unit: 'px'}"
                          [valuesMaxWidth]="{value: 60, unit: '%'}"
                          [data]="setKeyValueData()"></app-list-key-value>
    } @else {
      <form style="padding: 0" class="st-drawer-content st-form" nz-form [formGroup]="containerForm">
        <!-- Referencia del Contenedor (Requerido) -->
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Referencia</nz-form-label>
          <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
            <input type="text" nzSize="large" nz-input formControlName="containerRef"
                   placeholder="Introduce la referencia..." />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>Referencia</nz-form-label>
          <nz-form-control [nzErrorTip]="'Este campo es requerido'" nzHasFeedback>
            <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                       class="search-preffix contacts" nzShowSearch
                       formControlName="containerTypeId" nzPlaceHolder="Selecciona el Tipo...">
              <nz-option *ngFor="let type of typeList" [nzLabel]="type.description"
                         [nzValue]="type.id"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </form>
    }
  </div>

  <div *ngIf="!nzData.readonly" class="st-drawer-footer">
    <button (click)="close()" class="text-btn-14" nz-button nzType="text" nzShape="round" nzSize="large">Cancelar</button>
    <button (click)="editContainer()" [disabled]="!containerForm.valid"
            class="text-btn-14" nz-button nzType="primary" nzShape="round" nzSize="large">
      <app-st-icon *ngIf="creatingContainer" class="prefix" [name]="'progress_activity'" [bold]="true"></app-st-icon>
      <span>Guardar</span>
    </button>
  </div>
</div>

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>
<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>

<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor" [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>

